// Base URL for the Spheres Statamic API.
//
// Override per-environment via VUE_APP_API_URL (Vue CLI reads VUE_APP_* vars
// from .env files). Defaults to the live Forge-hosted backend so the app works
// out of the box without any env configuration.
export const API_BASE =
  process.env.VUE_APP_API_URL || "https://spheres.on-forge.com/api";